module.exports = __webpack_public_path__ + "static/media/DSC00240.fcfdbf4d.jpg";